import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@design-system';
import { FlaskConical } from 'lucide-react';

interface SampleClientsAlertDialogProps {
  open: boolean;
  loading?: boolean;
  onAcknowledge: () => void;
}

export function SampleClientsAlertDialog({
  open,
  loading,
  onAcknowledge,
}: SampleClientsAlertDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="bg-primary/10 mx-auto mb-2 flex size-12 items-center justify-center rounded-full">
            <FlaskConical className="text-primary size-6" />
          </div>
          <AlertDialogTitle className="text-center text-lg">
            Explore Waterlily with Sample Clients
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center text-sm">
            We've added sample client profiles to your dashboard so you can explore the full
            Waterlily experience, from care plans to insurance quotes, without needing to enter
            real client data first.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <Button
            className="w-full"
            onClick={onAcknowledge}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Got it'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
